import { render, staticRenderFns } from "./ModalMensaje.vue?vue&type=template&id=a5cad76c&scoped=true"
import script from "./ModalMensaje.vue?vue&type=script&lang=js"
export * from "./ModalMensaje.vue?vue&type=script&lang=js"
import style0 from "./ModalMensaje.vue?vue&type=style&index=0&id=a5cad76c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cad76c",
  null
  
)

export default component.exports